class MobileDrawer extends HTMLElement {
  constructor() {
    super();
    this.index = this.getAttribute('id');
    this.overlay = this.querySelector('.sidebar__overlay');
    this.toggleBtn = document.querySelector(`[data-drawer-toggle="${this.index}"]`);
    this.closeButtons = this.querySelectorAll(`[data-drawer-close="${this.index}"]`);
  }

  static observedAttributes = ["open"];
  subscribeOpenEvent = undefined;
  subscribeCloseEvent = undefined;

  attributeChangedCallback(name, oldValue, newValue) {
    if(name == 'open') {
      newValue == 'true' ? this.open() : this.close();
    }
  }

  connectedCallback() {
    this.toggleBtn?.addEventListener('click', (event) => {
      event.target.classList.toggle('open');
      event.target.classList.contains('open') ? this.open() : this.close();
    })

    this.overlay.addEventListener('click', () => {
      this.close();
    })

    this.closeButtons.forEach(btn => btn.addEventListener('click', () => {
      this.close();
    }));

    this.subscribeOpenEvent = subscribe(PUB_SUB_EVENTS.drawerOpen, (event) => {
      if(event) this.open(event);
    })

    this.subscribeCloseEvent = subscribe(PUB_SUB_EVENTS.drawerClose, (event) => {
      if(event) this.close(event);
    });
  }

  disconnectedCallback() {
    if (this.subscribeOpenEvent) {
      this.subscribeOpenEvent();
    }
    if (this.subscribeCloseEvent) {
      this.subscribeCloseEvent();
    }
  }

  open(event = null) {
    let index = this.index;
    if(event && event.source) {
      index = event.source;
    }
    document.querySelector(`[data-drawer="${index}"]`)?.classList.add('sidebar-opened');

    document.body.classList.toggle('drawer-opened');
    document.body.classList.toggle(`${index}-opened`); //AT-872
  }

  close(event = null) {
    let index = this.index;
    if(event && event.source) {
      index = event.source;
    }

    document.querySelector(`[data-drawer="${index}"]`)?.classList.remove('sidebar-opened');
    document.body.classList.remove('drawer-opened', 'drawer-opened--desktop');
    document.body.classList.remove(`${index}-opened`); //AT-872
    const currentToggleBtn = document.querySelector(`[data-drawer-toggle="${index}"]`);
    currentToggleBtn?.classList.remove('open');

    if(index.indexOf('size') > -1) {
      const event = new CustomEvent("closeCustomSelect");
      document.querySelector('[data-name="select-size"]').dispatchEvent(event);
    }
  }
}

customElements.define('mobile-drawer', MobileDrawer);

/*AT-850 Immagine menu gender
Triggera l'apertura di menu con gender selezionato se si atterra la prima
volta nel sito.*/
class imagesDrawerMenu extends HTMLElement {
  constructor() {
    super();
    this.currentImageGender = this;
   // this.recalcHeightOfContainer();
    this.init();

  }

  init() {
    this.currentImageGender.addEventListener('click', () => {
      document.body.classList.remove('gender-generic');
      document.querySelector(`#HeaderDrawer-${this.dataset.action}`).click();
    });
  }

  /*
  recalcHeightOfContainer() {
    const windowHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const localizationTestHeight = document.querySelector('.localization-test').offsetHeight;
    const genderImagesHeight = windowHeight + localizationTestHeight;
    document.querySelector('.gender-images').style.maxHeight = `${genderImagesHeight}px`;
  }
*/
}

customElements.define('images-drawer-menu', imagesDrawerMenu);
